import EnquirySliderSignUp from './EnquirySliderSignUp.component';

export default EnquirySliderSignUp;